"use client";

import React from "react";
import { ChevronUp, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function VisionaryLeadership() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="30021" id="richmonds-trusted-power-experts" className="relative h-screen min-h-[600px] w-full overflow-hidden bg-background text-foreground dark">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603327/img/humberg-truck-motion.png)] bg-cover bg-center bg-fixed bg-no-repeat" />
        {}
        <div className="absolute inset-0 bg-black/60" />
      </div>

      {}
      <div className="absolute top-1/2 left-0 z-20 hidden -translate-y-1/2 flex-col lg:flex">
        <Button variant="default" size="icon" className="h-16 w-12 rounded-none border-b border-white/20 bg-destructive text-white hover:bg-destructive/90" aria-label="Previous section">
          <ChevronUp className="h-6 w-6" />
        </Button>
        <Button variant="default" size="icon" className="h-16 w-12 rounded-none bg-destructive text-white hover:bg-destructive/90" aria-label="Next section">
          <ChevronDown className="h-6 w-6" />
        </Button>
      </div>

      {}
      <div className="relative z-10 mx-auto flex h-full max-w-7xl flex-col justify-center px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={cn("flex max-w-3xl flex-col items-start text-left transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
          <h1 className="font-sans text-5xl font-bold leading-[1.1] tracking-tighter text-white sm:text-6xl md:text-7xl">
            Richmond’s Trusted <br /> Power Experts
          </h1>

          <p className="mt-6 max-w-lg text-lg leading-relaxed text-slate-200 sm:text-xl">
            24/7 EMERGENCY SERVICE — No job too big or small. Family owned and 
            operated since 2013, serving Richmond, Sugar Land, and the Houston area.
          </p>

          <div className="mt-8">
            <Button asChild size="lg" className="h-14 rounded-none bg-destructive px-8 text-base font-semibold uppercase tracking-wide text-white shadow-lg transition-transform hover:bg-destructive/90 hover:scale-105 active:scale-95">
              <Link to="/ContactPage">Book Now</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}